import { MAP_QUERY_DEFAULTS } from "./appConstants"

const cannedQueries = {
    default: {
        scope: null,
        time: null,
        config: {
            view: { zoom: MAP_QUERY_DEFAULTS.ZOOM, center: MAP_QUERY_DEFAULTS.CENTER },
            status: MAP_QUERY_DEFAULTS.STATUS,
            dateRange: { start: MAP_QUERY_DEFAULTS.STARTDATE, end: MAP_QUERY_DEFAULTS.ENDDATE },
            priority: "NORM" // RUSH, SHRT, NORM, REMK, DSGN, EMER
        },
        data: null // params?
    },
    emergency: {
        scope: "all",
        time: new Date(),
        config: {
            view: { zoom: MAP_QUERY_DEFAULTS.ZOOM, center: MAP_QUERY_DEFAULTS.CENTER },
            status: "OPEN",
            dateRange: { start: null, end: null },
            priority: "EMER"
        },
        data: null
    },
    testQuery: { // Additional canned/saved queries should reside elsewhere?
        scope: "mapBounds",
        time: "2022-02-07T17:01:40.869Z",
        config: {
            view: {
                zoom: 12,
                center: { "lat": 37.84202774870408, "lng": -121.86532974243165 }
            },
            status: "OPEN",
            dateRange: { start: "2022-02-04T05:00:00.000Z", end: "2022-02-07T05:00:00.000Z" },
            priority: "NORM"
        },
        data: [[ // rename to params?
            [ -122.03750610351564, 37.74710041225793 ],
            [ -121.69315338134767, 37.74710041225793 ],
            [ -121.69315338134767, 37.93688694775037 ],
            [ -122.03750610351564, 37.93688694775037 ],
            [ -122.03750610351564, 37.74710041225793 ]
        ]],
        // Perhaps add if/when needed...
        summary: "Canned query for testing dynamic state setting and query loading/firing",
        name: "Test Query",
        id: "whatevs-1337-1"
    }
}

const actionTypes = {
    clear:      "CLEAR",
    replace:    "REPLACE",
    scope:      "SCOPE",
    time:       "TIME",
    config:     "CONFIG",
    view:       "VIEW",
    zoom:       "ZOOM",
    center:     "CENTER",
    status:     "STATUS",
    dateRange:  "DATERANGE",
    startDate:  "STARTDATE",
    endDate:    "ENDDATE",
    priority:   "PRIORITY",
    data:       "DATA"
}

function queryReducer(state, action) {
    switch (action.type) {
        case actionTypes.clear: {
            return defaultQuery
        }
        case actionTypes.replace: {
            return action.data
        }
        case actionTypes.scope: {
            return { ...state, scope: action.data }
        }
        case actionTypes.time: {
            return { ...state, time: action.data }
        }
        case actionTypes.config: {
            return { ...state, config: action.data }
        }
        case actionTypes.view: {
            return {
                ...state,
                config: {
                    ...state.config,
                    view: action.data
                }
            }
        }
        case actionTypes.zoom: {
            return {
                ...state,
                config: {
                    ...state.config,
                    view: {
                        ...state.config.view,
                        zoom: action.data
                    }
                }
            }
        }
        case actionTypes.center: {
            return {
                ...state,
                config: {
                    ...state.config,
                    view: {
                        ...state.config.view,
                        center: action.data
                    }
                }
            }
        }
        case actionTypes.status: {
            return {
                ...state,
                config: {
                    ...state.config,
                    status: action.data
                }
            }
        }
        case actionTypes.dateRange: {
            return {
                ...state,
                config: {
                    ...state.config,
                    dateRange: action.data
                }
            }
        }
        case actionTypes.startDate: {
            return {
                ...state,
                config: {
                    ...state.config,
                    dateRange: {
                        ...state.config.dateRange,
                        start: action.data
                    }
                }
            }
        }
        case actionTypes.endDate: {
            return {
                ...state,
                config: {
                    ...state.config,
                    dateRange: {
                        ...state.config.dateRange,
                        end: action.data
                    }
                }
            }
        }
        case actionTypes.priority: {
            return {
                ...state,
                config: {
                    ...state.config,
                    priority: action.data
                }
            }
        }
        case actionTypes.data: {
            // Test & translate bounds to polygon first. Move to helper?
            let tempData = action.data

            if (tempData && !Array.isArray(tempData) && typeof tempData !== 'string') {
                const { _northEast, _southWest } = tempData
                /*
                let formatted = [[
                    [_southWest.lng, _southWest.lat],
                    [_northEast.lng, _southWest.lat],
                    [_northEast.lng, _northEast.lat],
                    [_southWest.lng, _northEast.lat],
                    [_southWest.lng, _southWest.lat],
                ]]
                */
                let formatted = [[
                    [_southWest.lat, _southWest.lng],
                    [_northEast.lat, _southWest.lng],
                    [_northEast.lat, _northEast.lng],
                    [_southWest.lat, _northEast.lng],
                    [_southWest.lat, _southWest.lng],
                ]]

                return { ...state, data: formatted }
            } else {
                return { ...state, data: action.data }
            }
        }
        default: {
            console.log('tempQuery UPDATE failed: ', action)
        }
    }
}


export const defaultQuery = () => {
    //console.log('>> Current Query (set from default): ', cannedQueries.default)
    return cannedQueries.default
}

export const cannedEmergencyQuery = () => {
    //console.log('>> Emergency Query Loaded: ', cannedQueries.emergency)
    return cannedQueries.emergency
}

export const reduceQuery = (state, action) => {
    return queryReducer(state, action)
}
